import React, {useCallback, useEffect, useMemo, useState} from 'react';
import IPays from "../../models/IPays";
import useApi from "../../hooks/useApi";
import Guid from "../../models/Guid";
import {SelectBox, Button} from "devextreme-react/select-box";
import {EditorStyle} from "devextreme/common";
import IEditorOptions from "../../models/IEditorOptions";
import {useQuery} from "@tanstack/react-query";

;

function usePays(alwaysReadOnly?: boolean) {

    const {getData: getPays} = useApi<IPays[]>('pays');
    const {data: pays, refetch} = useQuery({queryKey: ['IPays'], queryFn: () => getPays()});
    const [currentSelectedItem, setCurrentSelectedItem] = useState<IPays>();


    const editorOptions = useMemo((): IEditorOptions<IPays[]> => {
        return {
            searchEnabled: true,
            dataSource: pays,
            displayExpr: "description",
            displayValue: "idPays",
            valueExpr: "idPays",
        }
    }, [pays])


    const PaysSelectBox = useCallback((params: any) => {
        if (!params?.datafield) params.datafield = "id_pays"
        const {dataField, component} = params;
        const formOptions = component.option();
        const value = formOptions.formData.hasOwnProperty(dataField) ? formOptions.formData[dataField] : dataField;

        const onValueChanged = (args: any) => {
            component.updateData(dataField, args.value);
            // setCurrentSelectedItem(args.value)
        }

        const onSelectionChanged = (e: any) => {
            setCurrentSelectedItem(e.selectedItem);
        }
        const currentPay = value ? pays?.find(f => f.idPays?.equals(value)) : undefined;

        undefined;
        return (
            <SelectBox className='custom-select-box-pays' onSelectionChanged={onSelectionChanged}
                       readOnly={alwaysReadOnly || formOptions.readOnly}
                       stylingMode={(alwaysReadOnly || formOptions.readOnly ? "underlined" : null) as EditorStyle}
                       dataSource={editorOptions.dataSource} displayExpr={editorOptions.displayExpr}
                       displayValue={editorOptions.displayValue} valueExpr={editorOptions.valueExpr} value={value}
                       onValueChanged={onValueChanged}>
                <Button location={"before"} key={"frm-idPays-btn"} name="drapeau" options={{
                    disabled: false,
                    stylingMode: "text",
                    icon: currentPay?.drapeau ? `data:image/png;base64,${currentPay?.drapeau}` : undefined,
                    visible: !currentPay?.idPays?.isEmpty()
                }}/>
            </SelectBox>
        )
    }, [editorOptions, currentSelectedItem, pays, alwaysReadOnly]);


    return {
        paysEditorOptions: editorOptions,
        pays,
        currentPays: currentSelectedItem,
        refreshData: () => refetch(),
        PaysSelectBox
    }
}

export default usePays;